import React from "react"
import { Col, Row } from "react-bootstrap"
import { commonStrings } from "../../../../../../core"
import { AutoPartsBar, CardOfferBar, MostRecentParts, NavbarLinks, PartsList } from "../../../../../../ds"
import { HomeData, IAdsHomeItem } from "../../../../business"
import { CarouselHero } from "./"


export const HomepageContent: React.FC<{ data: HomeData }> = ({ data }) => {
    const cs = commonStrings().PTBR;

    let carouselItems: Array<IAdsHomeItem> = [];
    const shouldAds = Object.keys(data.ads).length > 0
    if (shouldAds) {
        carouselItems = data.ads.images.map(image => ({
            description: data.ads.description,
            url: data.ads.url,
            image: image,
            showDescription: data.ads.show_description
        }));
    }
    const offersItems = [];
    // const offersItems = [
    //     { id: 1, text: "10% OFF", imageURL: "/logo192.png" },
    //     { id: 2, text: "20% OFF", imageURL: "/logo512.png" },
    //     { id: 3, text: "30% OFF", imageURL: "/logo512.png" },
    // ];

    return (<Row>
        <Col className="d-none d-lg-block">
            <MostRecentParts
                title={cs.mostRecent.title}
                items={data.mostRecentItens}
            />
        </Col>
        <Col xs={12} sm={12} md={12} lg={9}>
            <section className="d-none d-sm-inline">
                <NavbarLinks activeKey={1} />
            </section>
            {shouldAds &&
                <CarouselHero items={carouselItems} />
            }
            {offersItems.length > 0 &&
                <CardOfferBar offers={offersItems} navigate={[]} />
            }
            <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                    {typeof data.autopartSummary !== 'object' && <AutoPartsBar data={data.autopartSummary} cs={cs} />}
                    <PartsList
                        title={cs.mostViewed.title}
                        mt={typeof data.autopartSummary !== 'object' ? 5 : 3}
                        items={data.mostViewedItems}
                    />
                </Col>
            </Row>
        </Col>
    </Row>)
}